import React from 'react';
import SignatoriesVM from './SignatoriesVM';
import { observer } from 'mobx-react';
import { Neo, NeoGrid } from '@singularsystems/neo-react';
import LetterAuthorisationSignatory from '../../../Models/LetterAuthorisation/LetterAuthorisationSignatory';
import AsyncImageComponent from '../../../Components/AsyncImage';
import { NotificationDuration } from '../../../../App/Models/NotificationDuration';
import { NotifyUtils, Validation } from '@singularsystems/neo-core';
import { Catalogue } from '@singularsystems/neo-react-services';
import TitleCatalogueEntry from '../../Catalogue/GenericComponents/TitleCatalogueEntry';

interface ISignatoriesProps {
    viewModel: SignatoriesVM;
    onBackClicked: () => void;
}

@observer
export default class Signatories extends React.Component<ISignatoriesProps> {

    constructor(props: ISignatoriesProps) {
        super(props);
    }

    public render() {
        const viewModel = this.props.viewModel;

        return (
            <div>
                {!viewModel.editingSignatory &&
                    <Neo.Card title="Signatories">
                        <div className="mb-4">
                            <Neo.Button variant="light" icon="arrow-left" onClick={() => this.props.onBackClicked()}>Back</Neo.Button>
                        </div>
                        
                        <NeoGrid.Grid items={viewModel.signatoryList} addButton={{onClick: () => viewModel.editSignatory()}}>
                            {(item, meta) => (
                                <NeoGrid.Row>
                                    <NeoGrid.Column display={item.contactDetail.meta.firstName} />
                                    <NeoGrid.Column display={item.contactDetail.meta.lastName} />
                                    <NeoGrid.ButtonColumn editButton={{onClick: () => viewModel.editSignatory(item)}} />
                                </NeoGrid.Row>
                            )}
                        </NeoGrid.Grid>
                    </Neo.Card>}

                {viewModel.editingSignatory && this.renderSignatory(viewModel.editingSignatory)}
            </div>
        );
    }

    private renderSignatory(signatory: LetterAuthorisationSignatory) {
        const viewModel = this.props.viewModel,
            contact = signatory.contactDetail;

        return (
            <Neo.Card title={`${signatory.isNew ? "New" : "Edit"} signatory`}>

                <Neo.Form model={signatory} onSubmit={() => viewModel.saveSignatory()} validationDisplayMode={Validation.DisplayMode.Always}>

                    <div className="mb-4 d-flex justify-content-between">
                        <Neo.Button variant="light" icon="arrow-left" onClick={() => viewModel.editingSignatory = null}>Back</Neo.Button>
                        <Neo.Button icon="save" isSubmit pulse={signatory.readyToSave}>Save</Neo.Button>
                    </div>

                    <Neo.GridLayout lg={2}>
                        <div>
                            <Catalogue.FormGroupInline bind={contact.meta.titleId} catalogueType={TitleCatalogueEntry} />
                            <Neo.FormGroupInline bind={contact.meta.firstName} />
                            <Neo.FormGroupInline bind={contact.meta.lastName} />
                            <Neo.FormGroupInline bind={contact.meta.phoneNo} />
                            <Neo.FormGroupInline bind={contact.meta.emailAddress} />
                        </div>
                        <div>
                            <Neo.FormGroupInline 
                                bind={signatory.meta.userName}
                                footerText="Username of user who can sign on behalf of this signatory (usually their email address)." />
                            <Neo.FormGroupInline 
                                label="Signature"
                                bind={signatory.meta.imageFileDescriptorId} 
                                fileProps={{ uploadEndpoint: viewModel.imagesApiClient.getUploadImageUrl(), afterUpload: () => this.afterImageUpload() }} />

                            <AsyncImageComponent fileDescriptorId={signatory.imageFileDescriptorId} maxHeight="100px" className="mt-5 text-center" />
                        </div>
                    </Neo.GridLayout>
                </Neo.Form>
            </Neo.Card>
        )
    }

    private afterImageUpload() {
        NotifyUtils.addSuccess("Image uploaded", "Click save to link the image to the signatory.", NotificationDuration.Long);
    }
}